export const WHAT_YOU_GET_DISCRIPTION = [
  {
    title: 'Romantic mode',
    description: 'Flirt with AI-characters',
  },
  {
    title: 'Special characters',
    description: 'Pack of exclusive AIs for premium users',
  },
  {
    title: 'No limits',
    description: 'Conversations with no limits',
  },
  {
    title: 'Exclusive content',
    description: 'Get premium in-chat photos and videos',
  },
  {
    title: 'Priority responses',
    description: 'Instant replies for smooth conversation',
  },
];
